import PropTypes from "prop-types"

const PageSubTitle = ({ children, style, className }) => {
  return (
    <h2 className={`subtitle ${className || ""}`} style={style}>
      {children}
    </h2>
  )
}

PageSubTitle.defaultProps = {
  style: {},
}

PageSubTitle.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
}

export default PageSubTitle
